import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { get } from 'lodash';
import { PanelServiceWrapper } from '@ispm/shared/services/panel-service-wrapper.service';
import { IGenericPanelConfiguration } from '@ispm/layout/interfaces/generic-panel.interface';
import { ResolvableService } from '@ispm/core/services/resolvable.service';


@Component({
  selector: 'ispm-generic-panel',
  templateUrl: './generic-panel.component.html',
  styleUrls: ['./generic-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('GenericPanel')
export class GenericPanelComponent implements OnInit , IWidgetItem  {

  constructor(private panelServiceWrapper: PanelServiceWrapper) { }

  set widgetConfig(widgetConfig: IdynamicFormItem<any>) {
    this.widgetPanelConfig = get(widgetConfig, 'widgetPayload', { });
    if (this.widgetPanelConfig) {
      this.panelConfiguration = this.widgetPanelConfig;
    }
  }

  @Input()
  public panelConfiguration: IGenericPanelConfiguration;
  private widgetPanelConfig: any;
  @Input()
  public data: any;
  public widgetData: any;

  ngOnInit() {
  }

  showNavigationPanel() {
    const resolvedComp = ResolvableService.Resolve(this.panelConfiguration.componentToLoad);
    this.panelServiceWrapper.openPanel(resolvedComp, this.panelConfiguration, this.widgetData).subscribe(() => this.onNavigationClosed());
  }
  onNavigationClosed() {

  }
  getIcon()
  {
    return this.panelConfiguration &&  this.panelConfiguration.iconClass ? this.panelConfiguration.iconClass  :'icon__ChevronRight';
  }
}
